import { DomainType } from "models";

import type { KeyValue } from "@progress/kendo-react-form";
import type { DomainTypeEnum, IdDescriptionBase } from "models";

export interface NewEncounterForm {
  medicalRecordNumber: string;
  accountNumber?: string;
  facility: IdDescriptionBase | null;
  type?: IdDescriptionBase | null;
  domain?: DomainTypeEnum | null;
}

export interface ComboboxIdDescriptionBase extends IdDescriptionBase {
  displayValue: string;
}

export const mapDisplayValue = (item: IdDescriptionBase): ComboboxIdDescriptionBase => ({
  ...item,
  displayValue: `${item.id} - ${item.title}`,
});

export const formValidator = (fields: NewEncounterForm) => {
  const errors: KeyValue<string> = {};
  const isPSAEncounter = fields.domain === DomainType.Practice;
  const isFACEncounter = fields.domain === DomainType.Facility;

  if (!fields.medicalRecordNumber) {
    errors.medicalRecordNumber = "Medical Record Number is required";
  }

  if (!fields.facility) {
    errors.facility = isPSAEncounter ? "Practice is required" : "Facility is required";
  }

  if (isFACEncounter && fields.facility && !fields.type) {
    errors.type = "Encounter Type is required";
  }

  if (isPSAEncounter && !fields.accountNumber) {
    errors.accountNumber = "Account Number is required";
  }

  return Object.keys(errors).length ? errors : undefined;
};

export const COLUMNS = [
  { field: "id", header: "ID", width: "200px" },
  { field: "title", header: "Description", width: "300px" },
] as const;
